import { OnInit, Injectable } from '@angular/core';
import { EnvironmentService } from '../../core/environment/environment.service';


@Injectable({
    providedIn: 'root'
})

export class AlertTemplate implements OnInit {

    authSettings: any;
    urlOpenId: string;
    urlCadastroDemanda: string;

  constructor(private environmentService: EnvironmentService) {
    this.authSettings = this.environmentService.envModel.authSettings;
    this.urlOpenId = this.environmentService.envModel.appSettings.apiUrlLogout;
  }


  ngOnInit() {
  }


  template(id: number, language: string ){
    const template = [
        {
            id: 1,
            language:'br',
            title:"Sessão Expirada",
            html:'Desculpe, sua sessão expirou devido a inatividade. \n <a href="'+this.urlOpenId+'">Clique aqui</a> para fazer login novamente.'
        },
        {
            id: 1,
            language:'es',
            title:"Sessão Expirada",
            html:'Desculpe, sua sessão expirou devido a inatividade. \n <a href="'+this.urlOpenId+'">Clique aqui</a> para fazer login novamente. ES'
        },
        {
            id: 1,
            language:'us',
            title:"Sessão Expirada",
            html:'Desculpe, sua sessão expirou devido a inatividade. \n <a href="'+this.urlOpenId+'">Clique aqui</a> para fazer login novamente. US'
        },
        {
            id: 2,
            language:'br',
            title:"Erro ao efetuar login",
            html:'Problema ao efetuar login, gostaria de tentar novamente? \n <a href="'+this.urlOpenId+'">Clique aqui</a> para fazer login novamente.'
        },
        {
            id: 2,
            language:'es',
            title:"Erro ao efetuar login",
            html:'Problema ao efetuar login, gostaria de tentar novamente? \n <a href="'+this.urlOpenId+'">Clique aqui</a> para fazer login novamente. ES'
        },
        {
            id: 2,
            language:'us',
            title:"Erro ao efetuar login",
            html:'Problema ao efetuar login, gostaria de tentar novamente? \n <a href="'+this.urlOpenId+'">Clique aqui</a> para fazer login novamente. US'
        },
    ]
      return template.filter(x => x.id ===id && x.language === language);
  }

}
